import React, { memo } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { useMount } from "@sportal/cdk/hooks";
import { ModalService } from "@sportal/cdk/modal";
import { Icon } from "../../../../components/icon/Icon";
import { AddDeviceDialog } from "./AddDeviceDialog";
import {
  getMappedProfilesForSelect,
  isAddDeviceDisabled,
} from "../../../../store/profiles/profiles.selectors";
import { Button } from "../../../../components/button/Button";
import { fetchLogicalDevices } from "../../../../store/devices/logicalDevices";

import "./AddDevice.scss";

export const openAddDeviceModal = (currentProfile) => (dispatch, getState) => {
  const state = getState();
  const profiles = getMappedProfilesForSelect(state);

  const selectedProfile =
    currentProfile || _.find(profiles, ({ isDisabled }) => !isDisabled).value;

  ModalService.show((modal) => ({
    dialog: <AddDeviceDialog currentProfile={selectedProfile} modal={modal} />,
  })).catch(() => null);
};

interface AddDeviceButtonProps {
  className?: string;
  currentProfile?: string;
}

const AddDeviceButton = ({
  className,
  currentProfile,
}: AddDeviceButtonProps) => {
  const dispatch = useDispatch();

  useMount(() => {
    dispatch(fetchLogicalDevices());
  });

  const isDisabled = useSelector(isAddDeviceDisabled);

  const handleClick = () => {
    dispatch(openAddDeviceModal(currentProfile));
  };

  return (
    <div className={className}>
      <Button
        className="add-device-link"
        disabled={isDisabled}
        onClick={handleClick}
        data-testid="add-device-button"
        color={"secondary"}
      >
        <Icon icon="fa-regular fa-plus-circle" />
        <span>
          <FormattedMessage id="add_device" />
        </span>
      </Button>
    </div>
  );
};

AddDeviceButton.propTypes = {
  className: PropTypes.string,
  currentProfile: PropTypes.string,
};

export const AddDevice = memo(AddDeviceButton);
